/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */
import { RestService } from '../../RestService';

class ActionRequestProgMesService extends RestService {
    /** @ngInject */
    constructor($q, resource, $httpParamSerializerJQLike, $log) {
        super($q, resource,  $httpParamSerializerJQLike, $log, false);
        $log.debug('Service \'ActionRequestService\' loaded');
    }

    /**
     * Completes an action request prog mes.
     *
     * @param {Number} id Action request prog mes ID.
     * @returns {Promise} A promise providing the result.
     */
    complete(id) {
        return this.resource.complete({id}, {}).$promise;
    }

    /**
     * Reopens an action request prog mes.
     *
     * @param {Number} id Action request prog mes ID.
     * @returns {Promise} A promise providing the result.
     */
    reopen(id) {
        return this.resource.reopen({id}, {}).$promise;
    }

    /**
     * Closes an action request prog mes.
     *
     * @param {Number} id Action request prog mes ID.
     * @returns {Promise} A promise providing the result.
     */
    close(id) {
        return this.resource.close({id}, {}).$promise;
    }

    /**
     * Cancels an action request prog mes.
     *
     * @param {Number} id Action request prog mes ID.
     * @returns {Promise} A promise providing the result.
     */
    cancel(id) {
        return this.resource.cancel({id}, {}).$promise;
    }
}

export { ActionRequestProgMesService };



// WEBPACK FOOTER //
// ./src/main/front/scripts/module/actionrequest/service/ActionRequestProgMesService.js